import ToolTip from "../../ToolTip/ToolTip"



export const Uimodules_table_head = [
    {
        field: "sl_no",
        headerName: "Sl No",
    },
    {
        field: "module_id",
        headerName: "Module ID",
        width:120
    },
    {
        field: "module_name",
        headerName: "Module Name",
        width:200,
    },
    {
        field: "created_by",
        headerName: "Created By",
        width:200
    },
    {
        field: "created_on",
        headerName: "Created On",
        width:200,
    },
    {
        field: "edited_by",
        headerName: "Edited By",
        width:200
    },
    {
        field: "edited_on",
        headerName: "Edited On",
        width:200
    },
]